module.exports = __webpack_public_path__ + "static/media/SHMS.ff31db65.png";